// 절차적 텍스처 — 에셋 파일 없이 3색 규율(남색/흰색/주황) + 실루엣 + 눈 발광을 만든다.
// SpriteGPULayer는 '단일 텍스처'만 받으므로 모든 종류를 하나의 아틀라스 시트에 굽는다.

export const CELL = 32;                         // 셀 한 변
export const FRAMES = ['enemy', 'sheep', 'dog', 'shot', 'drop'];

export function bakeAtlas(scene) {
  if (scene.textures.exists('atlas')) return scene.textures.get('atlas');
  const w = CELL * FRAMES.length, h = CELL;
  const tex = scene.textures.createCanvas('atlas', w, h);
  const ctx = tex.getContext();
  ctx.clearRect(0, 0, w, h);

  const cx = CELL / 2;
  // 0 적 — 검은 실루엣 + 빨간 눈 두 점(발광)
  ctx.save(); ctx.translate(0, 0);
  ctx.fillStyle = '#0a0d18';
  ctx.beginPath(); ctx.ellipse(cx, cx + 2, 9, 7, 0, 0, 7); ctx.fill();
  ctx.beginPath(); ctx.ellipse(cx - 6, cx - 4, 5, 4, -0.4, 0, 7); ctx.fill();
  ctx.shadowColor = '#ff3b30'; ctx.shadowBlur = 8; ctx.fillStyle = '#ff5a4f';
  ctx.beginPath(); ctx.arc(cx - 7, cx - 5, 1.7, 0, 7); ctx.fill();
  ctx.beginPath(); ctx.arc(cx - 3, cx - 5, 1.7, 0, 7); ctx.fill();
  ctx.restore();

  // 1 양 — 흰 타원 + 머리 점
  ctx.save(); ctx.translate(CELL, 0); ctx.shadowBlur = 0;
  ctx.fillStyle = '#f2efe6';
  ctx.beginPath(); ctx.ellipse(cx, cx + 1, 9, 6.5, 0, 0, 7); ctx.fill();
  ctx.fillStyle = '#dcd6c8';
  ctx.beginPath(); ctx.arc(cx + 8, cx - 3, 3.2, 0, 7); ctx.fill();
  ctx.restore();

  // 2 개 — 회백 실루엣, 길쭉
  ctx.save(); ctx.translate(CELL * 2, 0);
  ctx.fillStyle = '#9aa0ad';
  ctx.beginPath(); ctx.ellipse(cx, cx + 1, 11, 5, 0, 0, 7); ctx.fill();
  ctx.beginPath(); ctx.arc(cx + 9, cx - 2, 3.6, 0, 7); ctx.fill();
  ctx.restore();

  // 3 투사체 — 작은 돌
  ctx.save(); ctx.translate(CELL * 3, 0);
  ctx.fillStyle = '#cfc6b0';
  ctx.beginPath(); ctx.arc(cx, cx, 2.6, 0, 7); ctx.fill();
  ctx.restore();

  // 4 드랍 — 낮은 채도의 젖빛 방울 (드랍 비주얼 절제 규칙)
  ctx.save(); ctx.translate(CELL * 4, 0);
  ctx.shadowColor = 'rgba(240,230,180,0.5)'; ctx.shadowBlur = 4;
  ctx.fillStyle = '#e8dfa8';
  ctx.beginPath(); ctx.arc(cx, cx, 3.1, 0, 7); ctx.fill();
  ctx.restore();

  tex.refresh();
  FRAMES.forEach((name, i) => tex.add(name, 0, i * CELL, 0, CELL, CELL));
  return tex;
}

// 모닥불 광원 — 조명 부하를 넣기 위한 방사 그라디언트
export function bakeLight(scene, radius = 420) {
  if (scene.textures.exists('light')) return scene.textures.get('light');
  const d = radius * 2;
  const tex = scene.textures.createCanvas('light', d, d);
  const ctx = tex.getContext();
  const g = ctx.createRadialGradient(radius, radius, 0, radius, radius, radius);
  g.addColorStop(0, 'rgba(255,168,74,0.55)');
  g.addColorStop(0.45, 'rgba(255,140,60,0.22)');
  g.addColorStop(1, 'rgba(255,120,40,0)');
  ctx.fillStyle = g; ctx.fillRect(0, 0, d, d);
  tex.refresh();
  return tex;
}
